// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';
// import less from 'less'
import './element.js'
import './icons/index' // icon
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import "slick-carousel/slick/slick.css";
import BaiduMap from 'vue-baidu-map'
// import '../static/css/common.css'
Vue.use(ElementUI)
// Vue.use(less)
Vue.config.productionTip = false
Vue.use(BaiduMap, {
  ak: 'HK8REl8sz56CFUZEXyX2FW9KWHkJFHes' // 这里填写你的百度地图ak
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js